var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'d-flex justify-content-'+_vm.alignLoader+' mb-5',staticStyle:{"margin-top":"50px"}},[_c('b-spinner',{style:('width: '+_vm.size+ 'rem; height:'+ _vm.size+ 'rem'),attrs:{"label":"Large Spinner"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec7a48fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = 635
// module chunks = 0